import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datetime';
import moment from 'moment';

import 'react-datetime/css/react-datetime.css';
import './DateTimeWidget.css';

class DateTimeWidget extends PureComponent {
  // This component sets a moment object on date change, but the jsonschema form
  // requires a string ISO date, so we need to make the switch when selecting.
  handleChange = (momentObj) => {
    const {
      onChange
    } = this.props;
    
    const date = momentObj.toDate().toISOString();

    onChange(date);
  };

  handleClear = () => {
    const {
      onChange
    } = this.props;

    // This is a limitation on react-jsonschema-form the value for date fields
    // can either be a string ISODate, or undefined. Null or empty strings are invalid.
    onChange(undefined);
  };
  
  render() {
    const {
      value,
      hasTimePicker
    } = this.props;
    
    const momentValue = moment(value);

    return (
      <DatePicker
        value={momentValue}
        onChange={this.handleChange}
        timeFormat={hasTimePicker}
        closeOnSelect
        dateFormat="MM/DD/YYYY"
        inputProps={{
          placeholder: 'Click to select a date',
          readOnly: true,
          className: 'form-control date-time-widget-input'
        }}
        renderInput={(props, openCalendar) => (
          <div className="input-group">
            <input {...props} onClick={openCalendar} />
            <span className="input-group-btn">
              <button
                type="button"
                className="btn btn-default clear-button"
                onClick={this.handleClear}
              >
                <span className="glyphicon glyphicon-remove clear-icon" />
              </button>
            </span>
          </div>
        )}
      />
    );
  }
}

/*------------------------------------------------*/
/* PROP TYPES
/*------------------------------------------------*/
DateTimeWidget.defaultProps = {
  value: '',
  onChange: () => {},
  hasTimePicker: false
};

DateTimeWidget.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  hasTimePicker: PropTypes.bool
};

export default DateTimeWidget;
